/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthorizationLeadWaitlistStatusSetByUserUserType } from './PalAuthorizationLeadWaitlistStatusSetByUserUserType';
import {
    PalAuthorizationLeadWaitlistStatusSetByUserUserTypeFromJSON,
    PalAuthorizationLeadWaitlistStatusSetByUserUserTypeFromJSONTyped,
    PalAuthorizationLeadWaitlistStatusSetByUserUserTypeToJSON,
} from './PalAuthorizationLeadWaitlistStatusSetByUserUserType';

/**
 * 
 * @export
 * @interface PalAuthorizationLeadWaitlistStatusSetByUser
 */
export interface PalAuthorizationLeadWaitlistStatusSetByUser {
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistStatusSetByUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistStatusSetByUser
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistStatusSetByUser
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistStatusSetByUser
     */
    title?: string;
    /**
     * 
     * @type {PalAuthorizationLeadWaitlistStatusSetByUserUserType}
     * @memberof PalAuthorizationLeadWaitlistStatusSetByUser
     */
    user_type?: PalAuthorizationLeadWaitlistStatusSetByUserUserType;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistStatusSetByUser
     */
    photo_url?: string;
}

/**
 * Check if a given object implements the PalAuthorizationLeadWaitlistStatusSetByUser interface.
 */
export function instanceOfPalAuthorizationLeadWaitlistStatusSetByUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthorizationLeadWaitlistStatusSetByUserFromJSON(json: any): PalAuthorizationLeadWaitlistStatusSetByUser {
    return PalAuthorizationLeadWaitlistStatusSetByUserFromJSONTyped(json, false);
}

export function PalAuthorizationLeadWaitlistStatusSetByUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthorizationLeadWaitlistStatusSetByUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'user_type': !exists(json, 'user_type') ? undefined : PalAuthorizationLeadWaitlistStatusSetByUserUserTypeFromJSON(json['user_type']),
        'photo_url': !exists(json, 'photo_url') ? undefined : json['photo_url'],
    };
}

export function PalAuthorizationLeadWaitlistStatusSetByUserToJSON(value?: PalAuthorizationLeadWaitlistStatusSetByUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'title': value.title,
        'user_type': PalAuthorizationLeadWaitlistStatusSetByUserUserTypeToJSON(value.user_type),
        'photo_url': value.photo_url,
    };
}

